/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { __ } from '../../../helpers/translations';
import Section from '../../common/Section';

import SectionHeader from './SectionHeader';

const research = [
  {
    title: __('G326'),
    links: [
      {
        authors: "Donia, M. B., O'Neill, T. A., & Brutus, S. (2018).",
        title: 'The longitudinal effects of peer feedback in the development and transfer of student teamwork skills.',
        url: 'https://www.sciencedirect.com/science/article/pii/S104160801730208X',
        publishers: 'Learning and Individual Differences, 61, 87-98.',
      },
      {
        authors: 'Dumond, P., & Galaleldin, M. (2020).',
        title: 'Modalities of peer assessments in team project based design courses.',
        url: 'https://dialnet.unirioja.es/servlet/articulo?codigo=7341324',
        publishers: 'The International journal of engineering education, 36(1), 461-469.',
      },
      {
        authors: 'Flanagan, K. M., & Addy, H. (2019).',
        title: 'Introverts Are Not Disadvantaged in Group-Based Active Learning Classrooms.',
        url: 'https://eric.ed.gov/?id=EJ1223951',
        publishers: 'Bioscene: Journal of College Biology Teaching, 45(1), 33-41.',
      },
      {
        authors: 'O’Neill, T. A., Boyce, M. A., & McLarnon, M. J. W. (in press).',
        title: 'Team health is improved when peer evaluation scores affect grades on team projects.',
        url: 'https://www.frontiersin.org/articles/10.3389/feduc.2020.00049/abstract',
        publishers: 'Frontiers in Education. doi: 10.3389/feduc.2020.00049',
      },
      {
        authors: 'O\'Neill, T. A., Deacon, A., Gibbard, K., Larson, N., Hoffart, G., Smith, J., & Donia, B. L. M. (2018).',
        title: 'Team dynamics feedback for post-secondary student learning teams.',
        url: 'https://srhe.tandfonline.com/doi/abs/10.1080/02602938.2017.1380161#.XBzXuq2-IdU',
        publishers: 'Assessment & Evaluation in Higher Education, 43(4), 571-585.',
      },
      {
        authors: 'O’Neill, T. A., Hoffart, G. C., McLarnon, M. M., Woodley, H. J., Eggermont, M., Rosehart, W., & Brennan, R. (2017).',
        title: 'Constructive controversy and reflexivity training promotes effective conflict profiles and team functioning in student learning teams.',
        url: 'https://journals.aom.org/doi/abs/10.5465/amle.2015.0183',
        publishers: 'Academy of Management Learning & Education, 16(2), 257-276.',
      },
      {
        authors: 'O’Neill, T. A., Larson, N., Smith, J., Donia, M., Deng, C., Rosehart, W., & Brennan, R. (2018).',
        title: 'Introducing a scalable peer feedback system for learning teams.',
        url: 'https://www.tandfonline.com/doi/abs/10.1080/02602938.2018.1526256',
        publishers: 'Assessment & Evaluation in Higher Education, 1-15.',
      },
      {
        authors: 'O’Neill, T. A., Pezer, L., Solis, L., Larson, N., Maynard, N., Dolphin, G., Brennan, R., & Li, S. (in press).',
        title: 'Team dynamics feedback for post-secondary student learning teams: Introducing the “Bare CARE” assessment and report.',
        url: 'https://www.tandfonline.com/doi/abs/10.1080/02602938.2020.1727412',
        publishers: 'Assessment and Evaluation in Higher Education. doi: 10.1080/02602938.2020.1727412',
      },
    ],
  },
  {
    title: __('G327'),
    links: [
      {
        authors: 'Cox, R. F. (2017).',
        title: 'Development and Assessment of Minimum Global/Cultural Requirements for all Undergraduates in the Purdue Polytechnic.',
        url: 'https://docs.lib.purdue.edu/cgi/viewcontent.cgi?article=1023&context=polytechsummit',
        publishers: '',
      },
      {
        authors: 'Galaleldin, M., Anis, H., Dumond, P., & Knox, D. (2017).',
        title: 'Scaffolding Strategies for Teaching Engineering Design in a Collaborative Project-based Learning Environment.',
        url: 'https://ojs.library.queensu.ca/index.php/PCEEA/article/view/10548/6948',
        publishers: 'Proceedings of the Canadian Engineering Education Association (CEEA).',
      },
      {
        authors: 'Gibbard, K., Griep, Y., Hoffart, G., & Onen, D. (2017).',
        title: 'One Big Happy Engineering Family? The Influence of Psychological Contracts on Team Outcomes and the Mediating Role of Person-team Fit.',
        url: 'https://ojs.library.queensu.ca/index.php/PCEEA/article/download/7386/7284',
        publishers: 'Proceedings of the Canadian Engineering Education Association (CEEA).',
      },
      {
        authors: 'Li, S., O’Neill, T. A., Brennan, R., Gress, G., Ebufegha, A. J., Lee, M. (2020, June).',
        title: 'Informing team dynamics of capstone projects using peer evaluation scores.',
        url: 'https://ojs.library.queensu.ca/index.php/PCEEA/article/view/14135/9226',
        publishers: 'Paper published in the proceedings of the annual conference of the Canadian Engineering Education Association, Montreal, QC.',
      },
      {
        authors: 'Parker, A. M., Watson, E., Ivey, M., & Carey, J. P. (2019).',
        title: 'Approaches to Graduate Attributes and Continual Improvement Processes in Faculties of Engineering Across Canada: A Narrative Review of the Literature.',
        url: 'https://ojs.library.queensu.ca/index.php/PCEEA/article/view/13736/9070',
        publishers: 'Proceedings of the Canadian Engineering Education Association (CEEA).',
      },
      {
        authors: 'Sanger, P. A., Friesel, A., Geraedts, H., Orellana, L. E. Q., Canahuire, R., & Berry, F. (2018, September).',
        title: 'International Capstone Student Projects Giving Real World, Global Team Experiences.',
        url: 'https://ieeexplore.ieee.org/abstract/document/8534205',
        publishers: 'In 2018 28th EAEEIE Annual Conference (EAEEIE) (pp. 1-9). IEEE.',
      },
      {
        authors: 'Usprech, J., & Lam, G. (2020, June).',
        title: 'Self-awareness and empathy as tools to mitigate conflict, promote wellness, and enhance performance in a third-year engineering design course.',
        url: 'https://legacy.itpmetrics.com/resources/CEEA_Paper_125_-_Usprech_and_Lam.pdf',
        publishers: 'Proceedings of the Canadian Engineering Education Association Conference, Montreal, QC, Canada.',
      },
    ],
  },
  {
    title: __('G328'),
    links: [
      {
        authors: 'Maybee, S. (2020).',
        title: 'Yes you can lead student teams, even in a virtual world.',
        url: 'https://www.nisod.org/2020/05/05/xlii_16/',
        publishers: 'NISOD Innovation Abstracts, Vol XLII, (16).',
      },
    ],
  },
  {
    title: __('G329'),
    links: [
      {
        authors: 'Allen, N. J., & O’Neill, T. A. (2015).',
        title: 'Team composition and performance: Considering the project team challenge.',
        url: 'https://global.oup.com/academic/product/the-psychology-and-management-of-project-teams-9780199861378',
        publishers: 'In E. K. Kelloway, B. Hobbs, & F. Chiocchio (Eds.), The psychology and management of project teams: An interdisciplinary perspective (pp. 301-328). Oxford University Press.',
      },
      {
        authors: 'Sheridan, P. (2018).',
        title: 'Student Development of Team-effectiveness Behaviours in Engineering Teams',
        url: 'https://tspace.library.utoronto.ca/bitstream/1807/91984/1/Sheridan_Patricia_201811_PhD_thesis.pdf',
        publishers: '(Doctoral dissertation).',
      },
    ],
  },
];

function Research() {
  return (
    <Section>
      <SectionHeader
        title={__('G309')}
        subtitle=""
      />
      <Row className="my-3 g-6 justify-content-md-center">
        <Col lg={10} className="text-center mt-0">
          <div>
            {__('G310')}
          </div>
          <br />
          <div style={{ fontSize: '0.7em' }}>
            <a href="https://legacy.itpmetrics.com/resources/whitepaper.docx" target="_blank" rel="noreferrer">
              {__('G311')}
            </a>
          </div>
        </Col>
        {research.map((resource, index) => (
          <Col lg={10} key={`research-${index}`}>
            <Card>
              <Card.Body>
                <Card.Title as="h5">
                  {resource.title}
                </Card.Title>
                {resource.links.map((link, linkIndex) => (
                  <Card.Body key={`research-${index}-button-${linkIndex}`}>
                    {link.authors}
                    {' '}
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: 'underline' }}
                    >
                      {link.title}
                    </a>
                    {' '}
                    {link.publishers}
                  </Card.Body>
                ))}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

    </Section>
  );
}

export default Research;
